/* eslint-disable @typescript-eslint/no-unused-vars */

import {
  ActionLogDTO,
  Address,
  AddressInfoDTO,
  AddressJudgmentResult,
  AddressVerifyRequest,
  AddressVerifyResponse,
  AiCargoDTO,
  AiResultResponse,
  AllocateDTO,
  AllocateRequest,
  BatchAllocateRequest,
  BizOperRequest,
  BizOperResponse,
  CancelShipmentRequest,
  CarParamConfigDTO,
  CarrierCountDTO,
  CarrierCountResponse,
  CityDTO,
  CommissionAuditRequest,
  CompanyAddRequest,
  CompanyAuditRequest,
  CompanyDetailResponse,
  CompanyEditRequest,
  CompanyPageResponse,
  CompanyQueryRequest,
  CompanyStatusRequest,
  CreditEditRequest,
  CustomOtherQuoteConfigDTO,
  CustomPlatformConfigPageResponse,
  CustomPlatformConfigQueryRequest,
  CustomPlatformConfigRequest,
  CustomPlatformConfigResponse,
  CustomerCreditResponse,
  CustomerFtlQuoteConfigDTO,
  CustomerQuoteConfigDTO,
  CustomerQuoteInfoDTO,
  CustomerQuoteInfoDetailDTO,
  CustomerQuoteServiceDetailDTO,
  CustomerResponse,
  CustomerUserConfigRequest,
  DriverAddRequest,
  DriverDetailResponse,
  DriverInfoDTO,
  DriverPageResponse,
  DriverQueryRequest,
  DriverStatusRequest,
  ExceptionDealDetailResponse,
  ExceptionDealRequest,
  ExceptionDetailResponse,
  ExceptionPageResponse,
  ExceptionQueryRequest,
  FCashOutApproveRequest,
  FCashOutListResponse,
  FCashOutQueryRequest,
  FCashOutResponse,
  FCustomerWalletRequest,
  FCustomerWalletResponse,
  FHistoryBillRequest,
  FRechargeApproveRequest,
  FRechargeListResponse,
  FRechargeQueryRequest,
  FRechargeRequest,
  FRechargeResponse,
  FTradeRequest,
  FTransactionResponse,
  FWalletResponse,
  FmcsaCarrier,
  FmcsaCarrierListVO,
  FmcsaQueryRequest,
  FmcsaReamrkResponse,
  FmcsaStatusRequest,
  FreightClassRequest,
  FtlAcceptRequest,
  FtlAddStopRequest,
  FtlAddressIdDTO,
  FtlAddressResponse,
  FtlAmountDTO,
  FtlCargoDTO,
  FtlExactAddressDTO,
  FtlExactQuoteRequest,
  FtlOrderAmountRequest,
  FtlOrderAmountResponse,
  FtlOrderBackRequest,
  FtlOrderBatchIdRequest,
  FtlOrderCreateRequest,
  FtlOrderDetailExtResponse,
  FtlOrderDriverUpdateRequest,
  FtlOrderListExtResponse,
  FtlOrderPickDateRequest,
  FtlOrderPriceUpdateRequest,
  FtlOrderQueryRequest,
  FtlOrderRefNumberUpdateRequest,
  FtlOrderRemarkUpdateRequest,
  FtlQuoteConfigDTO,
  FtlQuoteConfigPageResponse,
  FtlQuoteConfigQueryRequest,
  FtlQuoteConfigRequest,
  FtlQuoteConfigResponse,
  FtlQuoteInfoDTO,
  FtlQuoteInfoDetailDTO,
  FtlQuoteResponse,
  FtlQuoteResultDTO,
  FtlRearrangeRequest,
  FtlStopFeeInfoDTO,
  FtlTrackInfo,
  FtlTrackUrlRequest,
  FtlWaybillAllocateRequest,
  FtlWaybillAmountRecordDTO,
  FtlWaybillAmountUpdateRequest,
  FtlWaybillBolNoUpdateRequest,
  FtlWaybillDetailResponse,
  FtlWaybillListResponse,
  FtlWaybillPriceRequest,
  FtlWaybillPriceResponse,
  FtlWaybillRemarkUpdateRequest,
  FtlWaybillStatusRequest,
  FtlWaybillTrackLogResponse,
  FtlWaybillUpdateRequest,
  HazardInfoDTO,
  HelperInfoReqeust,
  IPage,
  LocalTime,
  LocalTimeReq,
  LocalTimeRes,
  MailQuoteConfigResponse,
  MainQuoteConfigPageResponse,
  MainQuoteConfigQueryRequest,
  MainQuoteConfigRequest,
  OrderAcceptRequest,
  OrderActionLogResponse,
  OrderAddressDTO,
  OrderAddressDTOReq,
  OrderAddressDTORes,
  OrderAmountRecordDTO,
  OrderAmountRequest,
  OrderAmountResponse,
  OrderBatchIdRequest,
  OrderBidPriceRequest,
  OrderBillToVo,
  OrderCargoDTO,
  OrderCountDTO,
  OrderCountResponse,
  OrderDetailResponse,
  OrderFileRequest,
  OrderListExtResponse,
  OrderPickDateRequest,
  OrderPickupInfoRequest,
  OrderPriceUpdateRequest,
  OrderQueryRequest,
  OrderQuoteDTO,
  OrderQuoteRequest,
  OrderQuoteResultResponse,
  OrderRefNumberUpdateRequest,
  OrderRequest,
  OrderSimpleCargoDTO,
  OrderSimpleInfoDTO,
  OrderTrackingDTO,
  OssFileResponse,
  OtherQuoteInfoDetailDTO,
  OwnerQueryRequest,
  OwnerUserAuditRequest,
  OwnerUserEditRequest,
  OwnerUserLevelRequest,
  OwnerUserPwdRequest,
  OwnerUserRequest,
  OwnerUserResponse,
  PackageItemsDTO,
  PageQuery,
  PlaceDetailResponse,
  PlaceResultDTO,
  PlaceResultResponse,
  PlaceSearchRequest,
  PlatformCommodityDTO,
  PlatformConfigDetailDTO,
  PlatformOrderCoreRequest,
  PlatformQuoteRateDTO,
  PlatformRateDetailDTO,
  ProviderDTO,
  QueryCityPageDTO,
  QueryPlatformDTO,
  QueryQuoteAmountDTO,
  QuoteConfigDTO,
  QuoteConfigUpdateDTO,
  QuoteConfigUpdateRequest,
  QuoteInfoDTO,
  QuoteInfoDetailDTO,
  QuoteOrderPriceDTO,
  QuoteResultResponse,
  QuoteServiceDetailDTO,
  RouteDetailResponse,
  R,
  SalesAmountReportResponse,
  SalesCustomerRequest,
  SalesCustomerResponse,
  SalesDetailResponse,
  SalesOrderCountRequest,
  SalesOrderRequest,
  SalesOrderResponse,
  SalesQueryRequest,
  SalesSimpleResponse,
  SalesUserRequest,
  SalesUserResponse,
  SalesUserStatusVo,
  ServiceExtraQuoteDetailDTO,
  ServiceOtherQuoteDetailDTO,
  ServiceQuoteConfigRequest,
  ServiceQuoteConfigResponse,
  ServiceQuoteConfigUpdateRequest,
  ServiceQuoteDetailDTOReq,
  ServiceQuoteDetailDTORes,
  ShipmentCountResponse,
  ShipmentDetailExtResponse,
  ShipmentPageExtResponse,
  ShipmentQueryRequest,
  ShipmentTrackResponse,
  SimpleDriverListResponse,
  SimpleDriverQueryRequest,
  SimpleTruckListResponse,
  SimpleTruckQueryRequest,
  SysDepartmentTreeVo,
  SysDepartmentVo,
  SysPermission,
  SysPermissionTreeVo,
  SysPermissionVo,
  SysRoleResultVo,
  SysRoleVo,
  SysUserOptionVo,
  SysUserPasswordVo,
  SysUserQueryVo,
  SysUserStatusVo,
  SysUserVo,
  TimeZoneDTO,
  TrackInfo,
  TrackQueryRequest,
  TransferCenterQueryRequest,
  TransferCenterRequest,
  TransferCenterResponse,
  TranslateRequest,
  TranslateResponse,
  TruckAddOrEditRequest,
  TruckBindRequest,
  TruckDetailResponse,
  TruckPageQueryRequest,
  TruckPageResponse,
  TruckStatusRequest,
  UpdateBatchIdDTO,
  UpdateQuoteConfigDisableDTO,
  UserInfoVo,
  UserLoginVo,
  WaybillActionLogFileResponse,
  WaybillActionLogResponse,
  WaybillBolNoUpdateRequest,
  WaybillCountDTO,
  WaybillCountResponse,
  WaybillDetailResponse,
  WaybillFileResponse,
  WaybillPlatformDTO,
  WaybillPriceRecordDTO,
  WaybillPriceRequest,
  WaybillPriceResponse,
  WaybillPriceUpdateRequest,
  WaybillQueryRequest,
  WaybillRemarkUpdateRequest,
  WaybillRouteInfoDTO,
  WaybillRouteResponse,
  WaybillTrackLogResponse,
  WaybillTruckUpdateRequest,
  WaybillUpdateDriverRequest,
  WaybillUpdateRequest,
  WnChannelCommissionDTO,
} from './type';
import request from '@/utils/request';

export class PlatformQuoteConfigService {
  // 更新
  public static saveOrUpdateQuoteConfigUsingPOST(quoteConfigDTO: QuoteConfigUpdateRequest): Promise<R<boolean>> {
    return request('POST', '/platformQuoteConfig/createOrUpdate', null, null, quoteConfigDTO, null, null);
  }

  // 查看平台报价详情
  public static getPlatformDetailUsingGET(serviceType: number): Promise<R<Array<ServiceQuoteConfigResponse>>> {
    return request('GET', '/platformQuoteConfig/platformDetail', null, { serviceType }, null, null, null);
  }
}
